'use client';

import { FC } from 'react';

import { Button } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { documentEdit } from '@purpur/library/icon/assets/document-edit';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

const DraftModeContainer = styled.div`
    position: fixed;
    left: ${getPurpurSpacing('200')};
    bottom: ${getPurpurSpacing('200')};
`;

export const DisableDraftModeButton: FC = () => {
    return (
        <DraftModeContainer>
            <form action="/public-web/api/content/disable-draft" method="get">
                <Button
                    type="submit"
                    variant="expressive"
                    iconOnly={true}
                    title="Draft mode is enabled - click here to disable it"
                    aria-label="Draft mode is enabled - click here to disable it"
                >
                    <Icon svg={documentEdit} />
                </Button>
            </form>
        </DraftModeContainer>
    );
};
